angular.module('MyApp')
  .controller('LogoutCtrl', function ($location, $auth, toastr, $rootScope) {

    //$scope.url_ = $rootScope.url_;

    sessionStorage.removeItem('id');
    sessionStorage.removeItem('mail');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('nom');

    $rootScope.qcmSelectionne = undefined;
    $rootScope.listeQCMlive = undefined;
    $rootScope.user = undefined;

    $rootScope.listeQCM = []

    if (!$auth.isAuthenticated()) {
      $location.path('/#/');
      return;
    }



    $auth.logout()
      .then(function () {
        sessionStorage.removeItem("id");
        sessionStorage.removeItem("mail");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("nom");

 
        delete $rootScope.qcmSelectionne;
        delete $rootScope.listeQCMlive;
        delete $rootScope.user;

        $rootScope.listeQCM = [];

        toastr.info('___Déconnexion___');
        $location.path('/#/');//document.location.href
        return;

      });
  });